'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationProps = undefined;

var _Pagination = require('./Pagination');

Object.defineProperty(exports, 'PaginationProps', {
  enumerable: true,
  get: function get() {
    return _Pagination.PaginationProps;
  }
});

var _Pagination2 = _interopRequireDefault(_Pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Pagination2["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./components/pagination/index.tsx
 ** module id = 215
 ** module chunks = 0
 **/